import { common } from "helpers";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// includes
import AgTable from "elements/AgTable";
import { api } from "helpers";
import ModalConfirm from "elements/modalConfirm";

function PermissionList() {
  // init
  const navigate = useNavigate();
  // state
  const [permission] = useState(common.getUserPermission());
  const [deleteData, setDeleteData] = useState(null);
  const [loading, setLoading] = useState(false);
  // effect
  useEffect(() => {
    if (!permission.includes("per")) {
      navigate("/profile");
    }
  }, []);
  // functions
  const callAction = (data) => {
    if (data.type == "Add" || data.type == "add") {
      navigate("/permissions/add");
    } else if (data.type == "Edit") {
      navigate("/permissions/edit/" + data.item._id);
    } else if (data.type == "Delete") {
      setDeleteData(data.item);
    }
  };

  const DeleteRecord = (item) => {
    setLoading(true);
    let data = {
      url: "permission",
      method: "DELETE",
      query: `/${item._id}`,
    };
    api.call(data, (res) => {
      if (res.status === 200) {
        common.notify("S", "Record has been removed");
        setDeleteData(null);
        setLoading(false);
      }
    });
  };

  return (
    permission.includes("per") && (
      <>
      <AgTable
        module="adminPermission"
        filterData={{
          status: { key: "isActive", value: "" },
          dateA: { key: "startDate", value: "", title: "Created Date From" },
          dateB: { key: "endDate", value: "", title: "Created Date To" },
        }}
        onAction={(data) => callAction(data)}
        actionPermission={common.accessTable(permission, [
          "pec",
          "peu",
          "per",
          "ped",
        ])}
      />
      {deleteData !== null && (
        <ModalConfirm
          loading={loading}
          onYes={() => DeleteRecord(deleteData)}
          onNo={() => setDeleteData(null)}
        />
      )}
      </>
    )
  );
}

export default PermissionList;
